import { useIntl } from 'react-intl';
import shift4Logo from '../../../assets/shift4Logo.svg';
import styles from './PreAuthenticationDetails.module.scss';

interface IPreAuthFooterProps {
	defaultTipPercentageValue: number | boolean | undefined;
}

const PreAuthFooter: React.FC<IPreAuthFooterProps> = ({ defaultTipPercentageValue }) => {
	const intl = useIntl();

	return (
		<div className={styles.preAuthFooter} id="preAuthFooter">
			<p className={styles.subText}>
				{defaultTipPercentageValue
					? intl.formatMessage(
						{ id: 'page:preAuthFooter:agreementWithTip:text' },
						{ tipPercentage: defaultTipPercentageValue }
					)
					: intl.formatMessage({ id: 'page:preAuthFooter:agreementWithoutTip:text' })
				}
			</p>
			<div className={styles.logoContainer}>
				<img src={shift4Logo} alt="shift4 logo" />
			</div>
		</div>
	);
};

export default PreAuthFooter;
